const oidcClient = require('oidc-client');

window.oidcClient = oidcClient;
